import { MeasurementSystem } from '../model/enums/measurement-system';
import { UnitConversionService } from '../services/unit-conversion/unit-conversion.service';

export function transformUnit(
  unit: string,
  measurementSystem: MeasurementSystem,
  unitConversionService: UnitConversionService
): string {
  return measurementSystem !== MeasurementSystem.Metric
    ? unitConversionService.transformName(MeasurementSystem.Metric, measurementSystem, unit)
    : unit;
}
